import React, { useEffect, useState } from "react";
import * as actionCreators from "../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Fade } from "react-bootstrap";
import axios from "axios";
import SpinnerLoading from "../Components/SpinnerLoading";
import Toast from "react-bootstrap/Toast";
import "../pages/styles.css";

function FilesMovt({ nameCompany, company }) {
  const [files, setFiles] = useState(null);

  const [loading, setLoading] = useState(false);
  const [upload, setUpload] = useState([]);
  
  const getFiles = async () => {
    console.log(company)
    let newCompany = company;
    if (!company) return;
    if (company === 51 ) newCompany = 1
    if (company === 52 ) newCompany = 2
    if (company === 54 ) newCompany = 4
    const url = `${process.env.REACT_APP_NODE_APP}/files/${newCompany}`;
    setLoading(true);
    await axios
      .get(url)
      .then((r) => {
        setUpload(r.data);
        setLoading(false);
      })
      .catch((r) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getFiles();
  }, []);

  return (
    <>
      <Fade appear in>
        <div className="abm">
          <div className="qs container max-shadow">
            <h1>Libros Rubrica</h1>
            <br />
            <br />
            {files && <p>{`Archivo: ${files.name}`}</p>}
            {loading ? (
              <SpinnerLoading />
            ) : upload.length >= 1 ? (
              <div className="conteiner">
                <div className="row">
                  {upload.map((file, ix) => (
                    <div className="col-sm-3" key={ix}>
                      <Toast>
                        <Toast.Header closeButton={false} className="pointer">
                          <img
                            src="holder.js/20x20?text=%20"
                            className="rounded me-2"
                            alt=""
                          />
                          <strong className="me-auto">
                            <a
                              href={`${file.url}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {file.name}
                            </a>
                          </strong>
                        </Toast.Header>
                      </Toast>
                      <br />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <h2 className="mt-5">No hay libros disponibles actualmente</h2>
            )}
          </div>
        </div>
      </Fade>
    </>
  );
}

function mapStateToProps(state) {
  return {
    nameCompany: state.mainReducer.nameCompany,
    company: state.mainReducer.company,
  };
}

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(FilesMovt);
